import React, { FC } from 'react'
import ProductStreamHeader from 'sharedComponents/ProductStream/ProductStreamHeader'

import FilterBar from 'sharedComponents/ProductFilter/FilterBar'
import { FilterContext } from 'sharedComponents/ProductFilter/FilterProvider'

interface ProductStreamHeaderContentProps {
  title?: string
  productCurrencyCode?: string
  stickyHeaderHeight?: number
}
const ProductStreamHeaderContent: FC<ProductStreamHeaderContentProps> = ({
  title,
  productCurrencyCode,
  stickyHeaderHeight,
}) => {
  return (
    <FilterContext.Provider value={{ productCurrencyCode }}>
      <ProductStreamHeader
        subHeader={<FilterBar />}
        title={title}
        stickyOffsetTop={stickyHeaderHeight}
      />
    </FilterContext.Provider>
  )
}

export default ProductStreamHeaderContent
